import { type SerializedPageStructure } from '@wix/document-services-types'

export const removeReferenceComponents = (
  page: SerializedPageStructure,
): SerializedPageStructure => ({
  ...page,
  components: page.components.filter(
    ({ componentType }) =>
      componentType !== 'wysiwyg.viewer.components.RefComponent',
  ),
})
